module.exports = __webpack_public_path__ + "media/assets/icons/funds-90406306ea22e349c094f4452e29e951.svg";